import React from 'react';
import { Spin } from 'antd';

const Loader = () => {
  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        background: '#fff',
        display: 'flex',
        flex: 1,
      }}
    >
      <Spin size="large" />
    </div>
  );
};

export default Loader;
